import { useMediaQuery } from "react-responsive";

export const useBreakPoint = (onChangePC?: (breakpoint: boolean) => void) => {
  const isPC = useMediaQuery(
    { query: "(min-width: 900px)", screen: true },
    undefined,
    onChangePC
  );
  return { isPC };
};
